const WandFill = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5454 13.5L6.75 3.70462C6.53571 3.5001 6.25086 3.38598 5.95463 3.38598C5.65839 3.38598 5.37354 3.5001 5.15925 3.70462L3.70462 5.15925C3.494 5.37036 3.37571 5.65641 3.37571 5.95462C3.37571 6.25284 3.494 6.53888 3.70462 6.75L13.4994 16.5454C13.7106 16.756 13.9966 16.8743 14.2948 16.8743C14.593 16.8743 14.8791 16.756 15.0902 16.5454L16.5454 15.0907C16.7563 14.8798 16.8748 14.5937 16.8748 14.2954C16.8748 13.9971 16.7563 13.711 16.5454 13.5V13.5ZM4.5 5.95462L5.95463 4.5L8.76713 7.3125L7.31194 8.76769L4.49944 5.95519L4.5 5.95462ZM1.125 9L2.25 7.875L3.375 9L2.25 10.125L1.125 9ZM7.875 2.25L9 1.125L10.125 2.25L9 3.375L7.875 2.25ZM1.125 2.25L2.25 1.125L3.375 2.25L2.25 3.375L1.125 2.25Z"
        fill="#9C9C9C"
      />
    </svg>
  );
};

export default WandFill;
